import { Person } from './person';
import { Address } from './address';
import { LookupItem } from '../models/lookup-item';
import { IVisaType } from './visa-type';
import { OptionItem } from './option-item';

export class ApplicantDetails {
  dob: string = '';
  title: LookupItem | null = null;
  titleOther: string = '';
  firstName: string = '';
  surname: string = '';
  email: string = '';
  phoneType: OptionItem | null = null;
  phoneCountryCode: string = '';
  phoneAreaCode: string = '';
  phoneNumber: string = '';
  countryResidence: string = '';
  currentResidentialAddress = new Address();
  passportNumber: string = '';
  passportCountry: LookupItem | null = null;
  hasApplicantCrime = false;
  applicantCrime: string[] = [];
  hasHealthCondition = false;
  healthCondition: string[] = [];
  hasPartner: string = '';
  hasChildren: string = '';
  partnerPassport: string = '';
  partnerDob: string = '';
  numChildren: string = '';
  childrenIncluded: string = '';
  biologicalOrAdopted: string = '';
  childList: Array<any> = new Array<any>();
  studyReasons: string = '';
  acceptedForStudy: string = '';
  nameOfCourse: string = '';
  enrolmentConfirmation: string = '';
  studentDependant: string = '';
  isDisabled: string = '';
  childType: string = '';
  stepChildDob: string = '';
  stepParentCare: string = '';
  adoptedBefore: string = '';
  soleyDependant: string = '';
  relationshipStatus: string = '';
  whenGoAustralia: string = '';
  education: LookupItem | null = null;
  Occupation: string = '';
  intendedOccupation: string = '';
  personList: Person[] = [];
  childrenNotIncluded: string = '';
  childrenNotIncludedList: Array<any> = new Array<any>();
  otherApplicants: string = '';
  inAustralia: string = '';
  location: LookupItem | null = null;
  holdAustralianVisa: string = '';
  arriveAustralia: string = '';
  visaType: IVisaType | null = null;
  visaExpire: string = '';
  departAustralia: string = '';
  refusedVisa: string[] = [];
  cancelledVisa: string[] = [];
  maritalStatus: LookupItem | null = null;
  hasJobOffer: string = '';
  partnerCitizen: string = '';
  resumeLocation: any = null;
  resumeFile: Array<any> = new Array<any>();
  inDetention: string = '';
  detentionFacility: string = '';

  public static getApplicantName(applicantDetails: ApplicantDetails | null) {
    return applicantDetails
      ? `${applicantDetails.firstName} ${applicantDetails.surname}`
      : '';
  }

  public static removePerson(applicantDetails: ApplicantDetails | null, person: Person) {
    if (applicantDetails) {
      const index = applicantDetails.personList.indexOf(person);
      if (index !== -1) {
        applicantDetails.personList.splice(index, 1);
      }
    }
  }
}